import QCarousel from './QCarousel.js'
import QCarouselSlide from './QCarouselSlide.js'
import QCarouselControl from './QCarouselControl.js'

export {
  QCarousel,
  QCarouselSlide,
  QCarouselControl
}
